import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckoutService } from '../../services/checkout/checkout.service';
import { environment } from '../../../environments/environment';
import { ConfigService } from 'src/app/services/config/config.service';
import { PlanFeatureService } from 'src/app/services/common/plan-feature.service';
import { FeatureFlagsService } from 'src/app/services/feature-flag/feature-flag.service';
import { ProductType, User } from 'src/app/interfaces/user';
import { PaymentConfigService } from 'src/app/services/payment-config/payment-config.service';
import { UserService } from 'src/app/services/user/user.service';
import {
  MULTI_PLAN_TOK_STRIPE_PLANS,
  getMultiPlanTokRequest,
} from 'src/app/constants/tok-payment.constants';

@Component({
  selector: 'app-tok-payment',
  templateUrl: './tok-payment.component.html',
  styleUrls: ['./tok-payment.component.scss']
})
export class TokPaymentComponent implements OnInit {
  private user: User;
  petName: string = '';
  public mainCardContent = [];
  public plan1Name: string;
  public plan1Title: string;
  public plan1YearlyPrice: string;
  public plan1Benefits: string[];
  public plan2Name: string;
  public plan2YearlyPrice: string;
  public userCurrentProductType: number;
  public isMultiPlanTok: boolean = false;

  public plan1Available: boolean = true;

  public plan1StripePlanId: string;
  public plan2StripePlanId: string;

  public readonly standardTokStripePlanId = environment.stripePlans.identiAlertTokBreeder;

  constructor(
    private checkoutService: CheckoutService,
    private route: ActivatedRoute,
    private router: Router,
    private planFeatureService: PlanFeatureService,
    private configService: ConfigService,
    private featureFlags: FeatureFlagsService,
    private paymentConfigService: PaymentConfigService,
    private userService: UserService,
  ) {
    this.user = this.route.snapshot.data.user as User;
    this.plan1Name = this.configService.getTextFromKey('1-plan-name');
    this.plan1Title = this.configService.getTextFromKey('1-plan-title');
    this.plan1YearlyPrice = this.configService.getTextFromKey('1-plan-yearly-price');
    this.plan1Benefits = this.configService.getListContentFromKey('1-plan-benefits');
    this.plan2Name = this.configService.getTextFromKey('2-plan-name');
    this.plan2YearlyPrice = this.configService.getTextFromKey('2-plan-yearly-price');
    this.userCurrentProductType = this.user?.productType;
    this.plan1YearlyPrice =
      this.paymentConfigService.getYearlyDisplayPrice(ProductType.BasicPlus) ?? this.plan1YearlyPrice;
    this.plan2YearlyPrice =
      this.paymentConfigService.getYearlyDisplayPrice(ProductType.Premium) ??
      this.configService.getTextFromKey('2-plan-yearly-price');

    this.plan1Available = this.paymentConfigService.isProductAvailable(ProductType.BasicPlus);

    this.redirectToDashboard();
  }

  ngOnInit(): void {
    // The URL has no pet name when the user is redirected here, e.g. after logging in again.
    this.petName =
      this.route.snapshot.queryParamMap.get('petName') ??
      this.userService.filterTokPets(this.user.pets)[0]?.name ??
      '';
    this.plan1Title = this.plan1Title.replace('{{petName}}', this.petName);
    this.mainCardContent = this.getMainPlanCardContent(this.petName);

    const multiPlanTokRequest = getMultiPlanTokRequest(this.user);
    this.isMultiPlanTok = !!multiPlanTokRequest && this.featureFlags.isEnabled('isTokPlanSelectionAvailable');

    if (this.isMultiPlanTok) {
      const multiPlanTokStripePlans = MULTI_PLAN_TOK_STRIPE_PLANS[multiPlanTokRequest.type];
      this.plan1StripePlanId = multiPlanTokStripePlans.plan1;
      this.plan2StripePlanId = multiPlanTokStripePlans.plan2;
    }
  }

  public buyTok(planId: string = this.standardTokStripePlanId) {
    this.checkoutService.checkout([planId]).subscribe();
  }

  public getMainPlanCardContent(petName: string) {
    return this.planFeatureService.getMainPlanContent(petName);
  }

  private redirectToDashboard() {
    !this.user.tokRequests.length && this.router.navigate(['/dashboard']);
  }
}
